import axios from "axios/index";

export default {
  createAutomation: ({commit}, payload) => {
    commit('ui/SHOW_OVERLAY', true, {root: true});
    axios({
      url: '/engine/automations',
      method: "POST",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        // commit('automations/ADD_AUTOMATION', response.data, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        /* eslint-disable */
        console.log(err);
      });
  },
  fetchGraph: ({commit}, params) => {
    const {objectId, cb, useOverlay} = params;
    let arrQuery = [];
    Object.keys(params).forEach(key => {
      if (key !== "cb" && key !== "objectId" && key !== "useOverlay") {
        arrQuery.push(`${key}=${params[key]}`);
      }
    });
    const txtQuery = arrQuery.length > 0 ? `?${arrQuery.join('&')}` : '';
    if (useOverlay) {
      commit('ui/SHOW_OVERLAY', true, {root: true});
    }
    axios({
      url: '/engine/graphs/' + objectId + txtQuery,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (useOverlay) {
          commit('ui/HIDE_OVERLAY', true, {root: true});
        }
        if (typeof cb === 'function') {
          try {
            cb(null, response.data);
          } catch (e) {
          }
        }
      })
      .catch(err => {
        if (useOverlay) {
          commit('ui/HIDE_OVERLAY', true, {root: true});
        }
        if (typeof cb === 'function') {
          try {
            cb(err);
          } catch (e) {
          }
        }
      });
  }
};